import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { StringUtils } from "~app/common/utils/string-utils";
import { ISearchExternArbetsorderResponse } from "./ISearchExternArbetsorderResponse";
export class ExternArbetsorderViewModel {
    constructor(private readonly model: ISearchExternArbetsorderResponse) {
    }

    get senastSkickadTillViol(): string {
        return DateUtils.formatDateString(this.model.skickatTillViol, DateUtils.datetimeformatWithoutMillis);
    }

    get senastUppdaterad(): string {
        return DateUtils.formatDateString(this.model.uppdateratViol, DateUtils.datetimeformatWithoutMillis);
    }

    get arbetsorderBeteckning(): string {
        return this.model.arbetsorderBeteckning;
    }

    get arbetsorderAnskaffningsform(): string {
        return this.model.arbetsorderAnskaffningsform;
    }

    get arbetsorderNamn(): string {
        return this.model.arbetsorderNamn;
    }

    get uppdragsgivare(): string {
        if (!ObjectUtils.isNullOrUndefined(this.model.ckLeverantorKod)) {
            return `${this.model.ckLeverantorNamn} (${this.model.ckLeverantorKod})`;
        }

        if (!ObjectUtils.isNullOrUndefined(this.model.uppdragsgivareKod)) {
            return `${this.model.uppdragsgivare} (${this.model.uppdragsgivareKod})`;
        }
        return this.model.uppdragsgivare;
    }

    get kontraktsansvarig(): string {
        if (!this.model.kontraktsansvarig) {
            return null;
        }

        return `${this.model.kontraktsansvarig} (${this.model.kontraktsansvarigKod || ""})`;
    }

    get kontraktsansvarigKod(): string {
        return this.model.kontraktsansvarigKod;
    }

    get ckLeverantorKod(): string {
        return this.model.ckLeverantorKod;
    }

    get produktionsomrade(): string {
        return this.model.produktionsomrade;
    }

    get avtalsobjekt(): string {
        return this.model.avtalsobjekt;
    }

    get transportforetag(): string {
        return this.model.transportforetag;
    }

    get arbetsorderId(): number {
        return this.model.arbetsorderId;
    }

    get transportAvslutad(): string {
        return DateUtils.formatDateString(this.model.transportAvslutad, DateUtils.datetimeformatWithoutMillis);
    }

    get transportPaborjad(): string {
        return DateUtils.formatDateString(this.model.transportPaborjad, DateUtils.dateformat);
    }

    get giltigFrom(): string {
        return DateUtils.formatDateString(this.model.giltigFrom, DateUtils.dateformat);
    }

    get giltigTom(): string {
        return DateUtils.formatDateString(this.model.giltigTom, DateUtils.dateformat);
    }

    get viol3(): boolean {
        return this.model.viol3;
    }

    get externArbetsorderStatus(): string {
        return this.model.externArbetsorderStatus;
    }

    get viol3Dirty(): boolean {
        return this.model.viol3Dirty;
    }

    get viol3Fel(): boolean {
        return this.model.viol3Fel;
    }

    get externArbetsorderFelmeddelande(): string {
        let msg = this.model.externArbetsorderFelmeddelande;

        if (this.viol3Dirty) {
            msg = StringUtils.appendWithPunctuation(msg, "Behöver uppdateras mot Viol3.");
        }

        if (this.viol3Fel) {
            msg = StringUtils.appendWithPunctuation(msg, "Fel vid uppdatering till Viol3.");
        }

        return msg;
    }
}
